import React from "react";

import { SupportedData } from "../../../utils/data-utils";
import { floatRounding } from "../../../utils/utils";

export function GenericValue({
  value,
  variableDef,
  showUnit,
}: {
  value: unknown;
  variableDef: SupportedData | undefined;
  showUnit?: boolean;
}) {
  const renderValue = () => {
    if (variableDef?.data_value.value_type === "enum") {
      return (value as string) || "\u00A0";
    }

    if (
      variableDef?.data_value.value_type === "float" ||
      variableDef?.data_value.value_type === "integer"
    ) {
      return typeof value === "number" ? floatRounding(value, 1) : "\u00A0";
    }

    return null;
  };

  return (
    <>
      {renderValue()}

      {showUnit && (
        <>
          {" "}
          {variableDef != null && "primary_unit" in variableDef
            ? variableDef.primary_unit
            : null}
        </>
      )}
    </>
  );
}
